import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MailIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mail"}/>
}
